import React, { useState, useEffect } from "react";
import { Form, Row, Col, Card, Button } from "react-bootstrap";
import "./index.scss";
import Header from "../../components/appLayout/header";
import AdresseService from "../../services/adresse";
import { useClientAuth } from "../../context/ClientAuthContext";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useNavigate } from "react-router-dom";

export default function BillingAddressForm() {
  const { currentClient } = useClientAuth();
  const [adresses, setAdresses] = useState([]);
  const [selectedAdresseId, setSelectedAdresseId] = useState({});
  const [showForm, setShowForm] = useState(true); // show form if no address or "add new"
  const [formData, setFormData] = useState({
    civilite: "",
    nom: "",
    prenom: "",
    numero: "",
    lieu: "",
    codePostal: "",
    ville: "",
    userId: currentClient?.userId || "",
  });

  useEffect(() => {
    const fetchAdresses = async () => {
      if (currentClient?.userId) {
        try {
          const service = new AdresseService();
          const res = await service.getAdressesByUser(currentClient.userId);
          if (res?.data?.length > 0) {
            setAdresses(res.data);
            setShowForm(false); // show cards instead of form
          }
        } catch (err) {
          console.log("Pas d'adresse pour le client", err);
          setShowForm(true);
        }
      }
    };
    fetchAdresses();
  }, [currentClient]);

  const handleSelectAdresse = (adresseId) => {
    setSelectedAdresseId(adresseId);
  };

  const handleAddNewAdresse = () => {
    setShowForm(true);
    setSelectedAdresseId(null);
    setFormData({
      civilite: "",
      nom: "",
      prenom: "",
      numero: "",
      lieu: "",
      codePostal: "",
      ville: "",
      userId: currentClient?.userId || "",
    });
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleCivilityChange = (e) => {
    setFormData({ ...formData, civilite: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (currentClient) {
      // ✅ Client connecté

      // formulaire rempli → création nouvelle adresse
      try {
        const requiredFields = [
          "civilite",
          "nom",
          "prenom",
          "numero",
          "lieu",
          "codePostal",
          "ville",
        ];
        for (let field of requiredFields) {
          if (!formData[field]) {
            toast.error(`Le champ ${field} est requis !`);
            return;
          }
        }

        const service = new AdresseService();
        const newAdresse = await service.createAdresse(formData);
        toast.success("Adresse enregistrée avec succès !");
        // envoyer newAdresse._id pour checkout/payment
        console.log("Adresse choisie:", newAdresse.data._id);
        console.log(newAdresse.data);
        setSelectedAdresseId(newAdresse.data);
        await localStorage.setItem(
          "clientAdresse",
          JSON.stringify(newAdresse.data)
        );
        window.location.href = "/livraison";
      } catch (err) {
        toast.error("Erreur lors de l'enregistrement : " + err.message);
      }
    } else {
      // 🔹 Client non connecté → sauvegarder dans localStorage

      const requiredFields = [
        "civilite",
        "nom",
        "prenom",
        "numero",
        "lieu",
        "codePostal",
        "ville",
      ];
      for (let field of requiredFields) {
        if (!formData[field]) {
          toast.error(`Le champ ${field} est requis !`);
          return;
        }
      }
      localStorage.setItem("guestAdresse", JSON.stringify(formData));
      toast.success("Adresse enregistrée pour invité !");
      window.location.href = "/livraison";
      console.log("Adresse invité:", formData);
    }
  };
  const handleSubmit1 = async (e) => {
    if (selectedAdresseId) {
      // adresse existante sélectionnée
      console.log("Adresse choisie:", selectedAdresseId);
      localStorage.setItem("clientAdresse", JSON.stringify(selectedAdresseId));
      window.location.href = "/livraison";
    }
  };
  const navigate = useNavigate();
  return (
    <>
      <ToastContainer position="top-right" autoClose={3000} />
      <div className="p-md-5 p-0 pt-md-3">
        <Header />
      </div>

      <div className="billing-form">
        <h6 className="title">ADRESSE DE FACTURATION</h6>

        {!showForm && adresses.length > 0 ? (
          <>
            <div className="adresse-cards">
              {adresses.map((addr) => (
                <Card
                  key={addr._id}
                  className={`mb-3 ${
                    selectedAdresseId._id === addr._id ? "selected" : ""
                  }`}
                  onClick={() => handleSelectAdresse(addr)}
                  style={{ cursor: "pointer" }}>
                  <Card.Body>
                    <p>{`${addr.civilite} ${addr.nom} ${addr.prenom}`}</p>
                    <p>
                      {addr.numero}, {addr.lieu}
                    </p>
                    <p>
                      {addr.codePostal} - {addr.ville}
                    </p>
                  </Card.Body>
                </Card>
              ))}
            </div>
            <button className="back-btn me-3" onClick={handleAddNewAdresse}>
              Ajouter une nouvelle adresse
            </button>
            <button
              className="next-btn-t mt-3 mt-md-0 "
              disabled={!selectedAdresseId}
              onClick={handleSubmit1}>
              SUIVANT
            </button>
          </>
        ) : (
          <Form onSubmit={handleSubmit}>
            {/* Civilité */}
            <Form.Group className="mb-3 mt-5">
              <Form.Label>
                Civilité <span className="required">*</span>
              </Form.Label>
              <div className="civility-options">
                <Form.Check
                  inline
                  label="Madame"
                  name="civilite"
                  type="radio"
                  value="Madame"
                  checked={formData.civilite === "Madame"}
                  onChange={handleCivilityChange}
                />
                <Form.Check
                  inline
                  label="Monsieur"
                  name="civilite"
                  type="radio"
                  value="Monsieur"
                  checked={formData.civilite === "Monsieur"}
                  onChange={handleCivilityChange}
                />
              </div>
            </Form.Group>

            {/* Nom et Prénom */}
            <Row>
              <Col md={6} className="mt-3">
                <Form.Group className="mb-3">
                  <Form.Control
                    type="text"
                    name="nom"
                    placeholder="NOM*"
                    value={formData.nom}
                    onChange={handleChange}
                    required
                    className="input-address"
                  />
                </Form.Group>
              </Col>
              <Col md={6} className="mt-3">
                <Form.Group className="mb-3">
                  <Form.Control
                    type="text"
                    name="prenom"
                    placeholder="PRENOM*"
                    value={formData.prenom}
                    onChange={handleChange}
                    required
                    className="input-address"
                  />
                </Form.Group>
              </Col>
            </Row>

            {/* Numéro */}
            <Form.Group className="mb-3">
              <Form.Control
                type="text"
                name="numero"
                placeholder="NUMERO*"
                value={formData.numero}
                onChange={handleChange}
                required
                className="input-address"
              />
            </Form.Group>

            {/* Lieu */}
            <Form.Group className="mb-3">
              <Form.Control
                type="text"
                name="lieu"
                placeholder="LIEU*"
                value={formData.lieu}
                onChange={handleChange}
                required
                className="input-address"
              />
            </Form.Group>

            {/* Code Postal + Ville */}
            <Row>
              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Control
                    type="text"
                    name="codePostal"
                    placeholder="CODE POSTAL*"
                    value={formData.codePostal}
                    onChange={handleChange}
                    required
                    className="input-address"
                  />
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Control
                    type="text"
                    name="ville"
                    placeholder="VILLE*"
                    value={formData.ville}
                    onChange={handleChange}
                    required
                    className="input-address"
                  />
                </Form.Group>
              </Col>
            </Row>

            <div className="form-actions ">
              <button
                className="back-btn "
                onClick={() => {
                  navigate("/all-products");
                  window.scrollTo(0, 0);
                }}>
                RETOUR A LA BOUTIQUE
              </button>
              <button type="submit" className="next-btn-t">
                SUIVANT
              </button>
            </div>
          </Form>
        )}
      </div>
    </>
  );
}
